/**
 * Diamond Buying Guide — sliders + FAQ + hero dropdowns
 */
(function () {
  'use strict';

  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }

  function qsa(root, sel) {
    return [].slice.call((root || document).querySelectorAll(sel));
  }

  function applyStepContent(root, sectionId, index) {
    var tpl = document.getElementById('dbg-info-' + sectionId + '-' + index);
    var headingEl = qs(root, '[data-dbg-info-heading]');
    var bodyEl = qs(root, '[data-dbg-info-body]');
    var ctaEl = qs(root, '[data-dbg-info-cta]');
    if (!headingEl || !bodyEl || !tpl || !tpl.content) return;

    var hd = tpl.content.querySelector('[data-part="heading"]');
    var bd = tpl.content.querySelector('[data-part="body"]');
    var ctaTextNode = tpl.content.querySelector('[data-part="cta-text"]');
    var ctaHrefNode = tpl.content.querySelector('[data-part="cta-href"]');

    headingEl.textContent = hd ? hd.textContent.trim() : '';
    bodyEl.innerHTML = bd ? bd.innerHTML : '';

    var txt = ctaTextNode ? ctaTextNode.textContent.trim() : '';
    var hrefPart = ctaHrefNode ? ctaHrefNode.textContent.trim() : '';

    if (ctaEl) {
      if (!txt && !hrefPart) {
        ctaEl.setAttribute('hidden', '');
        ctaEl.removeAttribute('href');
        ctaEl.textContent = '';
      } else {
        ctaEl.removeAttribute('hidden');
        ctaEl.setAttribute('href', hrefPart || '#');
        ctaEl.textContent = txt || hrefPart;
      }
    }
  }

  function initSlider(root) {
    if (!root || root.getAttribute('data-dbg-slider-init') === '1') return;
    var sectionId = root.getAttribute('data-slider-section-id');
    var range = qs(root, 'input.dbg-range__input');
    var img = qs(root, '.dbg-range__img');
    var live = qs(root, '.dbg-range__live');
    var railDots = qsa(root, '[data-dbg-rail-dot]');
    var tickBtns = qsa(root, '.dbg-range__tick-label');
    var steps = qsa(root, '.dbg-range__step');
    if (!steps.length) {
      root.setAttribute('data-dbg-slider-init', '1');
      return;
    }

    root.setAttribute('data-dbg-slider-init', '1');
    if (!range) return;
    var max = steps.length - 1;
    range.setAttribute('max', String(max));
    range.setAttribute('aria-valuemax', String(max));
    range.setAttribute('aria-valuemin', '0');

    function readStep(i) {
      var el = steps[i];
      if (!el) return null;
      return {
        src: el.getAttribute('data-src') || '',
        alt: el.getAttribute('data-alt') || '',
        label: el.getAttribute('data-label') || '',
      };
    }

    function applyIndex(i) {
      var n = Math.max(0, Math.min(max, parseInt(i, 10) || 0));
      var s = readStep(n);
      if (!s) return;

      if (img && s.src) {
        img.src = s.src;
        img.alt = s.alt;
      }

      if (sectionId) {
        applyStepContent(root, sectionId, n);
      }

      if (live) {
        live.textContent = s.label || '';
      }
      range.setAttribute('aria-valuenow', String(n));
      range.setAttribute('aria-valuetext', s.label || '');

      railDots.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === n);
      });

      tickBtns.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === n);
        d.setAttribute('aria-current', idx === n ? 'true' : 'false');
      });
    }

    range.addEventListener('input', function () {
      applyIndex(range.value);
    });
    range.addEventListener('change', function () {
      applyIndex(range.value);
    });

    tickBtns.forEach(function (tick, idx) {
      tick.addEventListener('click', function () {
        range.value = String(idx);
        applyIndex(idx);
        range.dispatchEvent(new Event('input', { bubbles: true }));
      });
      tick.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          tick.click();
        }
      });
    });

    applyIndex(range.value || 0);
  }

  function initSliders(scope) {
    qsa(scope, '[data-dbg-range]').forEach(initSlider);
  }

  function initCaratViz(root) {
    if (!root || root.getAttribute('data-dbg-carat-init') === '1') return;
    var range = qs(root, 'input.dbg-carat-viz__range');
    var diamond = qs(root, '[data-dbg-carat-diamond]');
    var live = qs(root, '.dbg-carat-viz__live');
    if (!range || !diamond) return;

    root.setAttribute('data-dbg-carat-init', '1');

    var minCt = parseFloat(root.getAttribute('data-min-ct'), 10) || 25;
    var maxCt = parseFloat(root.getAttribute('data-max-ct'), 10) || 200;
    var minPct = parseFloat(root.getAttribute('data-min-pct'), 10) || 18;
    var maxPct = parseFloat(root.getAttribute('data-max-pct'), 10) || 48;
    var decStr = root.getAttribute('data-decimals') || '2';
    var dec = Math.min(2, Math.max(0, parseInt(decStr, 10) || 2));

    var deskUrl = root.getAttribute('data-diamond-desk') || '';
    var mobUrl = root.getAttribute('data-diamond-mob') || '';
    var mql = window.matchMedia ? window.matchMedia('(max-width: 989px)') : null;

    function currentDiamondUrl() {
      if (mql && mql.matches && mobUrl) return mobUrl;
      return deskUrl || '';
    }

    function applyDiamondBgUrl() {
      var u = currentDiamondUrl();
      if (u) diamond.style.backgroundImage = "url('" + u.replace(/'/g, '\\') + "')";
    }

    if (mql && mobUrl) {
      var mqListener = function () {
        applyDiamondBgUrl();
      };
      if (mql.addEventListener) mql.addEventListener('change', mqListener);
      else if (mql.addListener) mql.addListener(mqListener);
    }

    var maxIdx = 100;

    function pctForCt(ct) {
      var span = maxCt - minCt;
      if (span <= 0) return minPct;
      var t = (ct - minCt) / span;
      return minPct + (maxPct - minPct) * t;
    }

    function formatCt(ctInt) {
      var carat = ctInt / 100;
      return carat.toFixed(dec);
    }

    function indexToCt(idx) {
      var i = Math.max(0, Math.min(maxIdx, parseFloat(idx, 10) || 0));
      return Math.round(minCt + ((maxCt - minCt) * i) / maxIdx);
    }

    function apply() {
      var ct = indexToCt(range.value);
      if (ct < minCt) ct = minCt;
      if (ct > maxCt) ct = maxCt;
      var pct = pctForCt(ct);
      diamond.style.backgroundSize = pct.toFixed(3) + '%';
      if (live) {
        live.textContent = formatCt(ct);
      }
      range.setAttribute('aria-valuetext', formatCt(ct) + ' carat');
    }

    applyDiamondBgUrl();
    range.addEventListener('input', apply);
    range.addEventListener('change', apply);
    apply();
  }

  function initCaratVizAll(scope) {
    qsa(scope, '[data-dbg-carat-viz]').forEach(initCaratViz);
  }

  function initFaq(section) {
    var details = qsa(section, '.dbg-faq__details');
    if (!details.length) return;
    if (section.getAttribute('data-faq-bound') === '1') return;
    section.setAttribute('data-faq-bound', '1');
    var exclusive = section.getAttribute('data-faq-exclusive') === 'true';
    if (!exclusive) return;
    details.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        details.forEach(function (other) {
          if (other !== d) other.open = false;
        });
      });
    });
  }

  function initFaqs(scope) {
    qsa(scope, '[data-dbg-faq]').forEach(initFaq);
  }

  function initHeroDropdowns(scope) {
    qsa(scope, '[data-dbg-hero-dropdown]').forEach(function (drop) {
      if (drop.getAttribute('data-dbg-drop-init') === '1') return;
      drop.setAttribute('data-dbg-drop-init', '1');
      var btn = qs(drop, '[data-dbg-hero-dropdown-trigger]');
      var panel = qs(drop, '.dbg-hero-dropdown__panel');
      if (!btn || !panel) return;

      function close() {
        panel.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
        drop.classList.remove('is-open');
      }

      function open() {
        qsa(document, '[data-dbg-hero-dropdown].is-open').forEach(function (other) {
          if (other === drop) return;
          var ob = qs(other, '[data-dbg-hero-dropdown-trigger]');
          var op = qs(other, '.dbg-hero-dropdown__panel');
          if (op) op.setAttribute('hidden', '');
          if (ob) ob.setAttribute('aria-expanded', 'false');
          other.classList.remove('is-open');
        });
        panel.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
        drop.classList.add('is-open');
      }

      function toggle() {
        if (panel.hasAttribute('hidden')) open();
        else close();
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggle();
      });

      document.addEventListener(
        'click',
        function (e) {
          if (!drop.contains(e.target)) close();
        },
        false
      );

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drop.classList.contains('is-open')) close();
      });
    });
  }

  function boot(scope) {
    initSliders(scope);
    initCaratVizAll(scope);
    initFaqs(scope);
    initHeroDropdowns(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    boot(ev.target);
  });
})();
